var DisplayToggleControl = require("components/utility/DisplayToggleControl");

var RosterContent = require("components/org/roster/RosterContent");
var DifferentiationTable = require("components/org/differentiation/DifferentiationTable");

var CurrentUser = require("lib/account/CurrentUser");
var RosterRouting = require("lib/routing/RosterRouting");
var OnboardingChecklist = require("components/users/teachers/onboarding/OnboardingChecklist");

import { provideLocationState } from "components/utility/hoc/LocationState";

// require("org/roster/roster_page.scss");

@provideLocationState(RosterRouting.getRouteState)
class RosterPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("RosterPage");
	}

	onViewChange(view) {
		$wr.redirect(RosterRouting.getPath({ activeView: view }));
	}

	changeOrg(orgIdentifier) {
		$wr.redirect(RosterRouting.getPath({
			activeView: this.props.locationState.activeView,
			orgIdentifier
		}));
	}

	render() {
		var { orgIdentifier } = this.props.locationState;

		var pageContent = (
			<RosterContent orgIdentifier={ orgIdentifier } 
				changeOrgIdentifier={ this.changeOrg } />
		);

		var onboardingChecklist = <OnboardingChecklist />;

		return (
			<div className="container rosterPage">
				{ onboardingChecklist }
				<header className="pageHeader">
					<h1>Student Roster</h1>
				</header>
				{ pageContent }
			</div>
		);
	}
};

RosterPage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object.isRequired
});

module.exports = RosterPage;


// WEBPACK FOOTER //
// ./modules/components/org/roster/RosterPage.js